import React, { Fragment, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import FBannerSpend from "../../components/FspendComponents/FBannerSpend/FBannerSpend";
import FCategoryContainer from "../../components/FCategoryContainer/FCategoryContainer";
import { getBanks, deleteBankbyId } from "../../api/banks";
import { AuthContext } from "../../context/AuthContext";
import FcardBank from "../../components/FcardBank/FcardBank";
import Swal from "sweetalert2";
import { usePideFiado } from "../../hooks/usePideFiado";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from "uuid";
import FInputt from "../../components/FInputt/FInputt";
import { useFormik } from "formik";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { ContractOutline } from "react-ionicons";

const WithdrawalScreen = ({ param }) => {
  const route = useNavigate();
  const { setLoading, checkToken, setAlert } = useContext(AuthContext);
  const [arrayBanks, setArrayBanks] = useState([]);
  const [bankSelected, setBankSelected] = useState(null);
  const [idempotencyKey, setIdempotencyKey] = useState(null);

  const { getPaymentMethod } = usePideFiado();

  useEffect(() => {
    formik.setFieldValue("amount", "");
    _getBanks();
  }, []);

  async function _getBanks() {
    checkToken()
    let _return = false;
    setLoading(true);
    try {
      const dataGetBanks = await getBanks();
      setLoading(false);
      const res = dataGetBanks.data;
      if (res.code == "PROCESS_OK") {
        setArrayBanks(res.data);
      }
    } catch (error) {
      setLoading(false);
      const res = error.response.data;
      if (res.code == "NOT_FOUND") {
        // Swal.fire({
        //   title: "Código incorrecto",
        //   text: "",
        //   imageUrl: require("../../components/assets/images/advertir.png"),
        //   imageWidth: 150,
        //   imageHeight: 150,
        //   confirmButtonColor: "#fd6e0d",
        // });
      }
    }
    return _return;
  }

  // const getPaymentMethods = async(amount)=>{
  //   let paymentMethods = await getPaymentMethod(
  //     484,
  //     484,
  //     'CASHOUT'
  //   );

  //   console.log(paymentMethods)

  //   if (paymentMethods.length == 1) {
  //     // route('BankScreen', {
  //     //     productId: paymentMethods[0].id,
  //     //     transferredAmount: amount
  //     // })
  // } else {
  //     route('/PaymentMethodScreen',  {state:{
  //       originCurrency: "484",
  //       destinationCurrencyId: 484,
  //       component: 'CASHOUT',
  //       amount: amount
  //     }}

  //     )
  // }
  // }

  const { processPayment } = useProcessor();

  useEffect(() => {
    setIdempotencyKey(uuidv4());
  }, []);

  const nextScreen = async (bankId, amount) => {
    if (true == true && idempotencyKey) {
      // const { productId } = route.params;
      const data = {
        originCurrencyId: "484",
        destinationCurrencyId: "484",
        exchangeRateId: null,
        products: [
          {
            id: "CASHOUT_BANK_ACCOUNT_MXN",
            paymentMethod: {
              paymentMethodId: bankId,
            },
            amount: parseInt(amount),
          },
          {
            id: "FIADO_FUNDS_AVAILABLE_MXN",
          },
        ],
      };

      //console.log(data)

      let response = await processPayment(data, idempotencyKey);

      if (response?.data?.code == "PROCESS_OK") {
        //setModalQuestionVisible(false)
        const next = () => { };

        Swal.fire({
          showCloseButton: true,
          title: 'Éxito',
          text: "La transferencia se realizó correctamente",
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          // iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        }).then((result) => {
          if (result.isConfirmed) {
            next();
          } else {
            next();
          }
        })
      } else if (response?.data?.code == "INVALID_ACCOUNT_NUMBER") {
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "número de cuenta inválido",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
        //setModalQuestionVisible(false)
      } else if (
        response?.data?.code == "YOU_REQUEST_CANNOT_BE_PROCESSED_AT_THIS_TIME"
      ) {
        //setModalQuestionVisible(false)

        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "Su solicitud no puede ser procesada",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })

      } else {
        //setModalQuestionVisible(false)
        Swal.fire({
          showCloseButton: true,
          title: 'Advertencia',
          text: "No pudimos procesar tu solicitud en este momento, por favor intenta mas tarde",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#fd6e0d',
          iconColor: "#fd6e0d",
          confirmButtonText: 'Entendido'
        })
      }
    }
  };

  const onClickBanks = (data) => {
    setBankSelected(data);

    Swal.fire({
      showCloseButton: true,
      // title: "CVV",
      input: "text",
      imageUrl: require("../../components/assets/images/cvv.png"),
      imageWidth: 150,
      imageHeight: 150,
      inputPlaceholder: "Cantidad a retirar",
      imageAlt: "Custom image",
      confirmButtonColor: "#fd6e0d",
      confirmButtonText: "Continuar",
      // customClass: {
      //   image: "rounded-full",
      //   confirmButton: "w-64 rounded-3xl",
      // },
    }).then((result) => {
      //getPaymentMethods(result.value)
      nextScreen(data.id, result.value);

      // if (result.isConfirmed) {
      //   const data = {
      //     paymentMethodId: selectCard.id,
      //     value: result.value,
      //   };
      //   console.log(data);
      // }
    });
  };

  const formik = useFormik({
    initialValues: {
      amount: 0,
    },
    onSubmit: async (values) => {
      let paymentMethods = await getPaymentMethod({
        input1: 484,
        input2: 484,
        component: "CASHOUT",
      });

      if (paymentMethods.length == 1) {
        route("/BankScreen", {
          state: {
            productId: paymentMethods[0].id,
            transferredAmount: values.amount,
          },
        });
      } else {
        route("/PaymentMethodScreen", {
          state: {
            originCurrency: "484",
            destinationCurrencyId: 484,
            component: "CASHOUT",
            amount: parseFloat(values.amount),
          },
        });
      }
    },
    validate: (values) => {
      const errors = {};

      if (values.amount == 0) {
        errors.amount = "El monto debe ser mayor a 0";
      }

      // if (isNaN(values.amount.replace("$", ""))) {
      //   errors.amount = "Ingresa una cantidad válida.";
      // }

      // if (values.amount <= 0 || parseFloat(values.amount) == NaN) {
      //   errors.amount = "Ingresa una cantidad válida.";
      // }

      return errors;
    },
  });

  return (
    <>
      <FBannerSpend
        imageUrl={require("../../components/assets/images/transferir-dinero.png")}
        title="Transferir a cuenta"
        description="Saldo Disponible"
      />

      <div className="w-full border-0 grid place-items-center pt-16 pb-20">
        <form
          onSubmit={formik.handleSubmit}
          className="w-full xs:w-[400px] sm:w-[500px]"
        >
          <FInputText
            type="CurrencyInput"
            title={"Ingresa la cantidad a retirar (MXN)"}
            maxLength={10}
            value={!formik.values.amount ? 0 : formik.values.amount}
            onChange={async (value) => {
              if (value == undefined){
                formik.setFieldValue("amount", value == undefined ? 0 : value);
              } else {
                if (!value.includes(".")) {
                  formik.setFieldValue("amount", value == undefined ? 0 : value);
                } 
              }              
            }}
            errorMessage={formik.errors.amount}
          />

          <Fbutton
            value={"Continuar"}
            disabled={!formik.isValid}
            onClick={formik.handleSubmit}
          />
        </form>
      </div>
    </>
  );
};

export default WithdrawalScreen;
